import React, { useState, useEffect, useCallback, useMemo, useRef, Profiler } from 'react'
import axios from 'axios';
import './ConsoleNavMenu.css';
import * as signalR from "@microsoft/signalr";
import {Point} from "leaflet/dist/leaflet-src.esm";
import { logger } from '../../utils/logger'
import DroneIcon from "../drone.svg";
import CopterIcon from "./map/copter.svg";
import CopterOfflineIcon from "./map/copter_offline.svg"
import PlaneIcon from "./map/plane.svg";
import PlaneOfflineIcon from "./map/plane_offline.svg";
import 'leaflet/dist/leaflet.css';
import L from "leaflet";
import {
    MapContainer,
    TileLayer,
    Marker,
    Popup,
    Polygon,
    FeatureGroup,
    useMapEvents,
    useMap,
    useMapEvent, Rectangle, Polyline, Tooltip
  } from 'react-leaflet';
import RotatedMarker from '../RotatedMarker';

const GPSMapIcon = new L.Icon({
    iconUrl: CopterIcon,
    iconRetinaUrl: CopterIcon,
    iconAnchor: new L.Point(10, 30),
    popupAnchor: new L.Point(0, 0),
    //shadowUrl: HeliIcon,
    //shadowSize: new Point(20, 70),
    //shadowColor: "#000000",
    //shadowAnchor: new L.Point(10, 30),
    backgroundColor: "rgba(0,0,0,0)",
    //image: HelicopterImage,
    iconSize: new Point(40, 40),
});

const GPSOfflineMapIcon = new L.Icon({
    iconUrl: CopterOfflineIcon,
    iconRetinaUrl: CopterOfflineIcon,
    iconAnchor: new L.Point(10, 30),
    popupAnchor: new L.Point(0, 0),
    backgroundColor: "rgba(0,0,0,0)",
    iconSize: new Point(40, 40),
});

const GPSPlaneMapIcon = new L.Icon({
    iconUrl: PlaneIcon,
    iconRetinaUrl: PlaneIcon,
    iconAnchor: new L.Point(10, 30),
    popupAnchor: new L.Point(0, 0),
    backgroundColor: "rgba(0,0,0,0)",
    iconSize: new Point(40, 40),
});

const GPSPlaneOfflineMapIcon = new L.Icon({
    iconUrl: PlaneOfflineIcon,
    iconRetinaUrl: PlaneOfflineIcon,
    iconAnchor: new L.Point(10, 30),
    popupAnchor: new L.Point(0, 0),
    backgroundColor: "rgba(0,0,0,0)",
    iconSize: new Point(40, 40),
});



const MemoMarker = React.memo(({ marker, icon, onClick, isOnline }) => {
    return (
        <RotatedMarker
            key={marker.imei}
            position={[marker.lat, marker.lng]}
            icon={icon}
            rotationAngle={-marker.yaw}
            eventHandlers={{
                click: () => onClick(marker)
            }}
        >
            <Tooltip direction="bottom" offset={[15, 20]} opacity={1}>
                {marker.imei}
            </Tooltip>
        </RotatedMarker>
    );
}, (prevProps, nextProps) => {
    // Сравнение: если координаты и yaw не изменились — не ререндерим
    return (
        prevProps.marker.lat === nextProps.marker.lat &&
        prevProps.marker.lng === nextProps.marker.lng &&
        prevProps.marker.yaw === nextProps.marker.yaw && 
        prevProps.isOnline === nextProps.isOnline &&
        prevProps.onClick === nextProps.onClick
    );
});

function ConsoleMap({currentDrone, udpateFocus, markerClick}){
    const protocol = new signalR.JsonHubProtocol();
    //const [map, setMap] = useState(null)
    const mapRef = useRef(null);;//useMap();
    const [hub, setHub] = useState(hubConnect);
    const [positions, setPositions] = useState([]);
    const [drone, setDrone] = useState(currentDrone);
    const [types, setTypes] = useState([]);

    const typeMap = useMemo(() => {
        const map = new Map();
        types.forEach(item => {
          map.set(item.imei, item.type);
        });
        return map;
      }, [types]);
    

    useEffect(() => {
        logger.debug("Console Map mount");

        axios.get('api/drone/getModemsPosition')
        .then(response => {
            setPositions(response.data);
            logger.info(response.data);
        })
        .catch(ex => {
            logger.console.error(ex);
            if(ex.response.status === 401) {
                window.location = "/login";
            }
        });

        axios.get('api/drone/getModemsType')
        .then(response => {
            setTypes(response.data);
            logger.info(response.data);
        })
    }, []);

    useEffect(() => {
        if (drone?.imei && currentDrone?.imei && drone.imei !== currentDrone.imei || drone === null) {
            setDrone(currentDrone);
        }
        
        if (drone?.imei && currentDrone?.imei || drone === null) {
            const exists = positions.some((item) => item.imei === currentDrone.imei);
            if(exists) {
                const pos = positions.find((item) => item.imei === currentDrone.imei);
                if (mapRef.current) {
                    mapRef.current.setView([pos.lat, pos.lng]);
                }
            }
        }
    }, [currentDrone, udpateFocus]);

    useEffect(() => {
        return () => {
            hub.stop();
        };
    }, []);

    function hubConnect(){
        let connection = new signalR.HubConnectionBuilder()
            .withUrl("api/drone-hub")
            .withAutomaticReconnect([0, 2000, 10000, 10000, 30000, 10000])
            .withHubProtocol(protocol)
            .build();;

        connection.on('MapPosition', (message) =>
        {
            //{imei: '1', lat: 46.964493, lng: 142.75, yaw: 276.95953}
            updatePosition(message);
        });

        connection.on('SetOnline', (message) => {
            setOnline(message);
        });


        connection.start();
        return connection;
    }

    const updatePosition = useCallback((msg) => {
        setPositions((prevMarkers) => {
            const itemExists = prevMarkers.some((item) => item.imei === msg.imei);

            if(itemExists) {
                return prevMarkers.map((marker) =>
                    marker.imei === msg.imei
                      ? { ...marker, lat: msg.lat, lng: msg.lng, yaw: msg.yaw, isOnline: msg.isOnline }
                      : marker
                  )
            } else {
                return [...prevMarkers, {imei: msg.imei, lat: msg.lat, lng: msg.lng, yaw: msg.yaw, isOnline: msg.isOnline}];
            }
        });
    }, []);

    const setOnline = useCallback((msg) => {
        setPositions((prevMarkers) => {
            const itemExists = prevMarkers.some((item) => item.imei === msg.imei);

            if(itemExists) {
                return prevMarkers.map((marker) =>
                    marker.imei === msg.imei
                      ? { ...marker, lat: marker.lat, lng: marker.lng, yaw: marker.yaw, isOnline: msg.isOnline }
                      : marker
                  )
            }
            return prevMarkers;
        });
    }, []);

    const handleMarkerClick = useCallback((marker) => {
        markerClick(marker.imei);
    }, [markerClick]);

    const callback = (id, phase, actualTime, baseTime, startTime, commitTime) => {
        logger.info(`${id}'s ${phase} phase: Actual: ${actualTime} ms`);
    }

    const getIcon = (imei, isOnline) => {
        const type = typeMap.get(imei);
        if (type === 1) return isOnline ? GPSPlaneMapIcon : GPSPlaneOfflineMapIcon;
        return isOnline ? GPSMapIcon : GPSOfflineMapIcon;
      };

    const renderedMarkers = useMemo(
        () =>
            positions.map((marker) => (
                <MemoMarker
                    key={marker.imei}
                    marker={marker}
                    icon={getIcon(marker.imei, marker.isOnline)}
                    onClick={handleMarkerClick}
                    isOnline={marker.isOnline}
                />
            )),
        [positions, updatePosition, currentDrone, types, markerClick]
    );


    return(
        <div
            style={{
            width: "100%",
            height: "100%",
            //height: "auto",
            //minHeight: "100%",
            position: "absolute",
            overflow: "hidden",
            //top: "55px",
            top: "0px",
            left: "0px",
            backgroundColor: "#000000",
            paddingLeft: 0,
            paddingRight: 0,
            zIndex: -1,
            }}
        >
            {/*<div className={'map_container'} style={{height: "100%", width: "100%", zIndex: "0", }}>*/}
            <MapContainer center={[51.990465, 41.158602]} 
                zoom={7} scrollWheelZoom={true} style={{height: "100%", width: "100%"}} zoomControl={false} whenCreated={(map) => (mapRef.current = map)}>
                <TileLayer
                attribution='&copy; google contributors'
                //url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                url="http://{s}.google.com/vt/lyrs=s,p&x={x}&y={y}&z={z}"
                subdomains={['mt0','mt1','mt2','mt3']}
                />
                {renderedMarkers}
            </MapContainer>
            
        </div>
    )
}

export default ConsoleMap;